// Components
import { Button, Input, Modal } from "components"

// Third-Party Libraries
import toast from "react-hot-toast"

// Types
import type { ErrorFetch, SuccessFetch } from "types"
import type { DetailDeleteType } from "../types"

// Utils
import { useApi, useToggle } from "utils"

export function DeletePurchaseOrderModal(params: {
  item: DetailDeleteType
  onSuccess: () => void
  toggle: () => void
}) {
  // Hooks
  const api = useApi()
  const { isActive, setActive } = useToggle(false)

  const onDelete = (): void => {
    setActive(true)

    toast.promise(
      api.delete(`/purchaseorder/delete/${params.item.purchase_order_id}`),
      {
        loading: "Loading...",
        success: (res: SuccessFetch<{ message: string }>) => res.data.message,
        error: (err: ErrorFetch<{ message: string }>) => err.response.data.message
      }
    ).then(() => {
      params.toggle()
      params.onSuccess()
    }).catch(() => {
    }).finally(() => {
      setActive(false)
    })
  }

  return (
    <Modal
      isOpen
      title="DELETE PURCHASE ORDER"
      closeModal={params.toggle}
    >
      <Modal.Body className="flex flex-col gap-3">
        <div className="text-error">Are you sure want to delete this data?</div>

        <Input
          disabled
          label="PO ID#"
          value={params.item.trx_code}
        />

        <Input
          disabled
          label="DATE"
          value={params.item.transaction_date}
        />

        <Input
          disabled
          label="VENDOR"
          value={params.item.vendor_name}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="button"
          color="error"
          loading={isActive ? "true" : undefined}
          onClick={onDelete}
          permission={"PR014"}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}